import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "rename"];
import { Input } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Password = props => {
  var {
      keyname = 'password',
      name,
      rename
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var key = keyname || name;
  return /*#__PURE__*/_jsx(Input, _extends({
    type: "password",
    placeholder: "Password",
    autoComplete: "on",
    index: 2
  }, elmProps, {
    name: name || rename || keyname,
    keyname: key
  }));
};
Password.displayName = 'BaseLogin.Password';